import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import WaiverTemplates from '../../components/history/modals/WaiverTemplates';
import FileMaintenance from '../../components/common/modals/FileMaintenance';
import Services from '../../components/services/modals/Services';
import OfficeUsers from '../../components/users/modals/OfficeUsers';
import RequirePermission from '../../components/RequirePermission';
import { SUB_MODULES } from '../../constants/subModulesConstants';

const MaintenancePage = () => {
    // const [type, setType] = useState([]);

    return (
        <>
          <Typography variant="h4">Maintenance</Typography>
          <List>
            <RequirePermission subModuleName={SUB_MODULES.USER_MANAGEMENT} minAccessLevel={1}>
              <OfficeUsers />
            </RequirePermission>
            <RequirePermission subModuleName={SUB_MODULES.SERVICES_PRICE_LIST} minAccessLevel={1}>
              <Services />
            </RequirePermission>
            <RequirePermission subModuleName={SUB_MODULES.WAIVER_TEMPLATES} minAccessLevel={1}>
              <WaiverTemplates />
            </RequirePermission>
            <RequirePermission subModuleName={SUB_MODULES.FILE_MAINTENANCE} minAccessLevel={1}>
              <FileMaintenance />
            </RequirePermission>
          </List>
        </>
    );
};

export default MaintenancePage;
